import { Box, Checkbox, Divider, FormControlLabel, FormGroup, Grid, Stack, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { CustomCheckedIcon, CustomUncheckedIcon } from "components/Core/CheckboxIcons";
import { MODULE_POSITION_SUMMARY, MODULE_REVENUE_DASHBOARD } from "components/Menu/config/constants";

export default function UserGrantItemCard({ userGrant, userGrantItem, onChange }) {
  const handleOnChange = (e) => {
    const _state = { ...userGrantItem };
    _state[e.target.name] = e.target.checked;
    onChange && onChange(_state);
  };

  return (
    <Paper
      sx={{ p: 1, pl: 2.5, pr: 2.5, backgroundColor: "background.paper", width: "100%" }}
      className="section-access"
    >
      <Grid container spacing={1} alignItems="center" className="heading">
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" spacing={1}>
            {userGrantItem?.icon}
            <Typography variant="h5" sx={{ m: 0, p: 0, mb: "0px !important" }}>
              {userGrantItem?.title}
            </Typography>
          </Stack>
        </Grid>
      </Grid>
      <Divider />
      <Grid container>
        <Grid item xs={12}>
          <Stack direction="row" spacing={1} alignItems="center" justifyItems="center">
            <FormGroup>
              <FormControlLabel
                disabled={userGrant?.is_master_read}
                name="is_read"
                control={
                  <Checkbox
                    checked={userGrantItem?.is_read || userGrant?.is_master_read || false}
                    onChange={handleOnChange}
                    icon={<CustomUncheckedIcon />}
                    checkedIcon={<CustomCheckedIcon disabled={userGrant?.is_master_read} />}
                  />
                }
                label="View"
              />
              {userGrantItem && ![MODULE_POSITION_SUMMARY, MODULE_REVENUE_DASHBOARD].includes(userGrantItem.module) && (
                <FormControlLabel
                  disabled={userGrant?.is_master_write}
                  name="is_write"
                  control={
                    <Checkbox
                      checked={userGrantItem?.is_write || userGrant?.is_master_write || false}
                      icon={<CustomUncheckedIcon />}
                      checkedIcon={<CustomCheckedIcon disabled={userGrant?.is_master_write} />}
                    />
                  }
                  onChange={handleOnChange}
                  label="Edit"
                />
              )}
            </FormGroup>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
}
